import React, { useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import Leftmenu from '../components/Leftmenu';
import Rightmenu from '../components/Rightmenu';
import { useOutletContext, useParams } from "react-router-dom";
import Campusback from '../../images/profile-banner.jpg';
import PostCard from '../components/PostCard';
import FriendCardMain from '../components/FriendCardMain';
import df from "../../images/Default_pfp.jpg";

const formatDate = (dateStr) => {
    if (!dateStr) return "";
    try {
        const parts = dateStr.split('-');
        if (parts.length === 3) {
            const d = new Date(parts[0], parts[1] - 1, parts[2]);
            return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
        }
        return dateStr;
    } catch (e) {
        return dateStr;
    }
};

function UserProfile() {
    const { user, token } = useOutletContext();
    const [posts, setPosts] = useState([]);
    const [userdata, setUserdata] = useState(null);
    const [connection, setConnection] = useState([]);
    const { id } = useParams();

    const userWorkHistory = userdata?.professional_details?.work_histories
        || userdata?.professional_details?.workHistories
        || [];
    const currentJob = userWorkHistory.find(j => j.is_current == 1 || j.is_current === true || j.is_current === "1")
        || (userWorkHistory.length > 0 ? userWorkHistory[0] : null);

    // Pagination
    const loaderRef = useRef(null);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const getUserinfo = () => {
        fetch('/api/get-userinfo', {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: id })
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.extraerror) {
                    console.error(data.extraerror);
                } else if (data.userdata && data.message) {
                    setUserdata(data.userdata);
                    setConnection(data.connection);
                }
            })
            .catch((error) => console.error("Error fetching user info:", error));
    };

    const getPosts = () => {
        if (loading || !hasMore) return;
        setLoading(true);

        fetch('/api/get-user-posts?page=' + page, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: id })
        })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data?.data?.data && data.data.data.length > 0) {
                    setPosts((prevPosts) => [...prevPosts, ...data.data.data]);
                    setHasMore(data.data.data.length > 0);
                } else {
                    setHasMore(false);
                }
            })
            .catch((error) => {
                console.error("Error fetching posts:", error);
                setLoading(false);
                setHasMore(false);
            });
    };

    useEffect(() => {
        if (user?.id == id) {
            window.location.href = '/profile';
            return;
        }
        getUserinfo();
        getPosts();
    }, [id]);

    // Watch for loader in viewport
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setPage((prevPage) => {
                        if (!loading && hasMore) {
                            return prevPage + 1;
                        }
                        return prevPage;
                    });
                }
            },
            { threshold: 0.1 }
        );

        if (loaderRef.current) observer.observe(loaderRef.current);
        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, [loading, hasMore]);

    useEffect(() => {
        if (page > 1) {
            getPosts();
        }
    }, [page]);

    const profilePic = userdata?.personal_details?.profile_picture || df;

    return (
        <div>
            <Header />
            <Leftmenu />
            <Rightmenu />

            <div className="main-content right-chat-active">
                <div className="middle-sidebar-bottom">
                    <div className="middle-sidebar-left">
                        <div className="row">
                            {/* Profile Header Card */}
                            <div className="col-lg-12">
                                <div className="card w-100 border-0 p-0 bg-white shadow-xss rounded-xxl overflow-hidden mb-3">
                                    <div className="card-body h250 p-0 rounded-xxl overflow-hidden m-3 position-relative">
                                        <img
                                            src={Campusback}
                                            alt="Campus Banner"
                                            style={{ width: '100%', height: '300px', objectFit: 'contain', objectPosition: 'center center' }}
                                        />
                                    </div>

                                    <div className="card-body p-0 position-relative pb-3">
                                        <figure className="avatar-2 position-absolute w100 z-index-1" style={{ top: '-45px', left: 30 }}>
                                            <img
                                                src={profilePic}
                                                alt={userdata?.name || "User Avatar"}
                                                className="float-right p-1 bg-white rounded-circle w-100 shadow-md"
                                                style={{ aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center' }}
                                            />
                                        </figure>

                                        <div className="d-flex flex-wrap justify-content-between align-items-center pl-15 pe-4 pt-2">
                                            <div>
                                                <h4 className="fw-700 font-sm mb-1 text-grey-900 d-flex align-items-center gap-2">
                                                    {userdata?.name}
                                                    <span
                                                        className="badge rounded-pill text-uppercase font-xsssss px-2 py-1 fw-bold text-white"
                                                        style={{ backgroundColor: '#E42026' }}
                                                    >
                                                        {userdata?.role || "Member"}
                                                    </span>
                                                </h4>

                                                {currentJob && currentJob.designation && (
                                                    <p className="fw-600 font-xssss text-grey-600 mb-1">
                                                        <i className="feather-briefcase me-1 text-grey-500"></i>
                                                        {currentJob.designation}
                                                        {(currentJob.organisation || currentJob.organization) && ` at ${currentJob.organisation || currentJob.organization}`}
                                                    </p>
                                                )}


                                            </div>

                                            <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
                                                <FriendCardMain data={connection} type="profile-tag" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-body d-block w-100 shadow-none mb-0 p-0 border-top-xs">
                                        <ul className="nav nav-tabs h55 d-flex product-info-tab border-bottom-0 ps-4">
                                            <li className="list-inline-item me-4 active">
                                                <span className="fw-700 font-xssss pt-3 pb-3 ls-1 d-inline-block text-dark border-bottom border-danger border-2">
                                                    Overview
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Left Sidebar Info Cards */}
                            <div className="col-xl-4 col-xxl-3 col-lg-4 pe-lg-0">
                                {/* About / Bio */}
                                <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
                                    <div className="card-body d-block p-4">
                                        <h4 className="fw-700 mb-2 font-xsss text-grey-900 d-flex align-items-center gap-2">
                                            <i className="feather-info text-danger"></i> About
                                        </h4>
                                        <p className="fw-500 text-grey-600 lh-24 font-xssss mb-0">
                                            {userdata?.personal_details?.bio || "No bio added yet."}
                                        </p>
                                    </div>
                                </div>

                                {/* Professional Info */}
                                <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
                                    <div className="card-body p-4">
                                        <h4 className="fw-700 mb-3 font-xsss text-grey-900 d-flex align-items-center gap-2">
                                            <i className="feather-briefcase text-danger"></i> Professional
                                        </h4>

                                        {userdata?.professional_details?.employability_status || (userdata?.professional_details?.work_status && userdata.professional_details.work_status !== 'none') ? (
                                            <div className="mb-3 d-flex flex-wrap gap-2">
                                                {userdata.professional_details.employability_status && (
                                                    <div>
                                                        <small className="text-grey-500 fw-600 font-xsssss text-uppercase d-block mb-1">Status</small>
                                                        <span className="badge bg-light text-dark font-xssss fw-600 px-3 py-1 rounded-pill border text-capitalize">
                                                            {userdata.professional_details.employability_status}
                                                        </span>
                                                    </div>
                                                )}
                                                {userdata.professional_details.work_status && userdata.professional_details.work_status !== 'none' && (
                                                    <div>
                                                        <small className="text-grey-500 fw-600 font-xsssss text-uppercase d-block mb-1">Work Status</small>
                                                        <span className="badge bg-light text-dark font-xssss fw-600 px-3 py-1 rounded-pill border text-capitalize">
                                                            {userdata.professional_details.work_status.replace(/_/g, ' ')}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (!userWorkHistory || userWorkHistory.length === 0) ? (
                                            <p className="font-xssss text-grey-500 mb-0">No professional details added yet.</p>
                                        ) : null}

                                        {/* Experience */}
                                        <div className="mt-3 pt-3 border-top">
                                            <h5 className="fw-700 font-xsss text-grey-900 mb-3">Experience</h5>
                                            {userWorkHistory && userWorkHistory.length > 0 ? (
                                                userWorkHistory.map((job, idx) => {
                                                    const isCurrent = job.is_current == 1 || job.is_current === true || job.is_current === "1";
                                                    const startFormatted = formatDate(job.start_date);
                                                    const endFormatted = isCurrent ? "Present" : (formatDate(job.end_date) || "Present");
                                                    const dateDisplay = startFormatted ? `${startFormatted} - ${endFormatted}` : (endFormatted === "Present" ? "Present" : "");

                                                    return (
                                                        <div key={idx} className={`pb-2 ${idx !== userWorkHistory.length - 1 ? 'mb-3 border-bottom border-light' : ''}`}>
                                                            <h6 className="font-xsss fw-700 text-grey-900 mb-0">
                                                                {job.organisation || job.organization}
                                                            </h6>
                                                            <p className="font-xssss fw-600 text-grey-700 mb-1">
                                                                {job.designation}
                                                            </p>
                                                            {dateDisplay && (
                                                                <span className="font-xsssss text-grey-500 d-block">
                                                                    <i className="feather-calendar me-1"></i>
                                                                    {dateDisplay}
                                                                </span>
                                                            )}
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <p className="font-xssss text-grey-500 mb-0">No professional experience added yet.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Academic Info */}
                                {userdata?.academic_details && (
                                    <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
                                        <div className="card-body p-4">
                                            <h4 className="fw-700 mb-3 font-xsss text-grey-900 d-flex align-items-center gap-2">
                                                <i className="feather-award text-danger"></i> Education
                                            </h4>

                                            {userdata.academic_details.graduation_degree && (
                                                <div className="mb-2">
                                                    <small className="text-grey-500 fw-600 font-xsssss text-uppercase d-block mb-1">Graduation</small>
                                                    <h5 className="font-xsss fw-700 text-grey-900 mb-0">
                                                        {userdata.academic_details.graduation_degree}
                                                        {userdata.academic_details.graduation_course && ` (${userdata.academic_details.graduation_course})`}
                                                    </h5>
                                                    <p className="font-xssss fw-500 text-grey-600 mb-0">
                                                        {userdata.academic_details.graduation_institution || "Techno India University, Tripura"}
                                                    </p>

                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Right Column: User Posts */}
                            <div className="col-xl-8 col-xxl-9 col-lg-8">
                                {posts.length > 0 ? (
                                    posts.map((post) => (
                                        <PostCard key={post.id} post={post} />
                                    ))
                                ) : (
                                    !loading && (
                                        <div className="card w-100 text-center shadow-xss rounded-xxl border-0 p-5 mb-3">
                                            <i className="feather-file-text font-xl text-grey-400 mb-2"></i>
                                            <h5 className="fw-700 font-xs text-grey-700 mb-1">No Posts Yet</h5>
                                            <p className="text-grey-500 font-xssss mb-0">This user hasn't shared any updates yet.</p>
                                        </div>
                                    )
                                )}

                                <div
                                    ref={loaderRef}
                                    className="card w-100 text-center shadow-xss rounded-xxl border-0 p-4 mb-3 mt-3"
                                >
                                    {hasMore ? (
                                        <div className="snippet mt-2 ms-auto me-auto">
                                            <div className="stage">
                                                <div className="dot-typing"></div>
                                            </div>
                                        </div>
                                    ) : (
                                        <p className="text-muted mb-0 font-xssss">You have reached the end</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserProfile;
